"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.491 5.048C9.296 2.118 5.181.808 2.627 3.36A3.879 3.879 0 001.5 6.088c0 1.06.434 2.024 1.127 2.728a3.838 3.838 0 002.728 1.127c.915 0 1.744-.337 2.409-.867-.145 1.889-2.13 3.585-3.21 3.845l.502 1.561a8.792 8.792 0 004.52-2.611c1.349-1.465 1.917-4.356.915-6.823zm11.5 0c-1.195-2.93-5.31-4.24-7.864-1.687A3.879 3.879 0 0013 6.088c0 1.06.434 2.024 1.127 2.728a3.838 3.838 0 002.728 1.127c.915 0 1.744-.337 2.409-.867-.145 1.889-2.13 3.585-3.21 3.845l.502 1.561a8.792 8.792 0 004.52-2.611c1.349-1.465 1.917-4.356.915-6.823zM22 19H2v2h20v-2z" }), "Quote");
//# sourceMappingURL=Quote.js.map